


















import { Component, Vue } from "@/shared/vuepack";

import Terms from "@/employee/components/onboarding/Terms.vue";
import { useThemeStore } from "@/shared/store/theme";
import { UserTermsType } from "@/shared/types";
import { useLoginPromptOrchestratorStore } from "@/employee/store/LoginPromptOrchestrator";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";

@Component({
  components: {
    Terms,
  }
})
export default class TermsModal extends Vue {
  themeStore = useThemeStore();
  loginPromptOrchestratorStore = useLoginPromptOrchestratorStore();
  hsabAccountsStore = useHsabAccountsStore();
  UserTermsType = UserTermsType;

  get showModal () {
    return this.loginPromptOrchestratorStore.isTermsSignatureRequired;
  }

  onComplete () {
    this.loginPromptOrchestratorStore.dismissTerms();
  }

  get userHasHsaAccount () {
    return this.hsabAccountsStore.userHasHsaAccount;
  }

  onHidden () {
    // do the thing
  }
}
